export default function googleMapsConsentEventRunner() {
    document.body.dispatchEvent(new CustomEvent('googlemapsconsent',
        {detail: {acceptedGoogleMaps: window.BorlabsCookie.checkCookieConsent('googlemaps')}}));
}
